import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';

const UserProfileModal = styled.div``;
const ProfileSection = styled.div`
  padding: var(--space-10) var(--space-10) var(--space-10) var(--space-16);
  display: flex;
  justify-content: space-between;
  gap: var(--space-12);
  .closeIcon {
    height: max-content;
  }
`;
const Profile = styled.div``;
const NameSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
`;
const Name = styled.p`
  ${Typography.body_lg_medium};
  color: var(--text-primary);
  margin: var(--space-0);
`;

const EmailSection = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
  .copyIcon {
    display: none;
    ${mobile_xl(css`
      display: flex;
    `)}
  }
`;

const RedirectSection = styled.div`
  padding: var(--space-2) var(--space-16) var(--space-12);
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  .button {
    width: 100%;
  }
`;
const ButtonSection = styled.div``;
const TimeAndStatusSection = styled.div`
  box-shadow: var(--top-border);
  padding-block: var(--space-8);
  ${FlexCenter}
`;

const BulletIcon = styled.div`
  background-color: var(--text-tertiary);
  border-radius: var(--border-radius-full);
  width: 4px;
  height: 4px;
  margin-inline: var(--space-8);
`;
const Time = styled.p`
  ${Typography.body_sm};
  color: var(--text-secondary);
  margin: var(--space-0);
`;
const UserInfo = styled.div`
  display: flex;
  gap: var(--space-8);
  margin-top: var(--space-6);
  width: 100%;
  &:hover .copyIcon {
    display: flex;
  }
`;
const Email = styled.p`
  ${Typography.body_md};
  color: var(--text-secondary);
  margin: var(--space-0);
  max-width: 142px;
  overflow: hidden;
  text-overflow: ellipsis;
  ${mobile_xl(css`
    max-width: 250px;
  `)}
`;
export {
  UserProfileModal,
  ProfileSection,
  BulletIcon,
  ButtonSection,
  EmailSection,
  Name,
  NameSection,
  Profile,
  RedirectSection,
  Time,
  TimeAndStatusSection,
  UserInfo,
  Email
};
